export default defineNuxtRouteMiddleware(async (to) => {
    if (to.name === 'task_category_without_city' || to.name === 'master_category_without_city') {
        // Используем синхронный способ получения данных о пользователе для SSR
        const userStore = useUserStore()
        await nextTick()
        
        const citySlug = userStore.currentCity?.slug || 'all'

        let newRouteName = 'task_category'
        if(to.name === 'task_category_without_city') {
            newRouteName = 'task_category'
        } else if(to.name === 'master_category_without_city') {
            newRouteName = 'master_category'
        }
        
        // Используем 301 редирект для постоянного перенаправления
        // и для правильной индексации поисковыми системами
        return navigateTo({
            name: newRouteName,
            params: {
                city: citySlug,
                slug: to.params.slug
            }
        }, { 
            redirectCode: 301, // Постоянное перенаправление
            external: false    // Внутренний редирект (в рамках приложения)
        })
    }
}) 